export const environment = {
  production: true,
  sentryDSN: "https://d3a9e84c5e16d3593d8f77df2f083539@o4508794577092608.ingest.de.sentry.io/4508794615627856",
  apiURL: 'https://ankerslot-server.azurewebsites.net',
  websiteName: 'Sluitplanmaken.nl',
  clarityProjectId: "q666yab023"
};
